import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// components
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Features from "./components/Features";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import HowItWorks from "./data/howItWorksData";

//  Pages
import About from "./pages/About";
import Service from "./pages/Service";
import Careers from "./pages/Careers";
import Policies from "./pages/Policies";
import Contact from "./pages/Contact";
import CustomerPrivacy from "./pages/policies/CustomerPrivacy";
import CustomerTerms from "./pages/policies/CustomerTerms";
import DriverPrivacy from "./pages/policies/DriverPrivacy";
import DriverTerms from "./pages/policies/DriverTerms";
import CustomerFAQ from "./pages/faqs/CustomerFaqs";
import DriverFAQ from "./pages/faqs/DriverFaqs";

function Home() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Features />
      <CTA />
    </>
  );
}

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Service />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/policies/customer-privacy"element={<CustomerPrivacy />}/>
        <Route path="/policies/customer-terms" element={<CustomerTerms />} />
        <Route path="/policies/driver-privacy" element={<DriverPrivacy />} />
        <Route path="/policies/driver-terms" element={<DriverTerms />} />
        <Route path="/policies/customerfaqs" element={<CustomerFAQ />} />
        <Route path="/policies/driverfaqs" element={<DriverFAQ />} />

      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
